<template>
  <div id="page-product-details">
    <section-risk-codes-additive-form
        v-model="model"
        ref="form"
        :loading="loading"
        @deleteRiskCode="deleteRiskCode"
    />
  </div>
</template>

<script>

import NotificationMixin from '@/components/mixins/NotificationMixin';
import ViewModelMixin from '@/components/mixins/ViewModelMixin';
import SaveModelMixin from '@/components/mixins/SaveModelMixin';
import SectionRiskCodesAdditiveForm from '@/views/pages/facilities/sections/risk-codes/SectionRiskCodesAdditiveForm';
import CanAccessMixin from "@/components/mixins/CanAccessMixin";

export default {
  name: "SectionRiskCodes",
  components: {
    SectionRiskCodesAdditiveForm,
  },
  mixins: [SaveModelMixin, ViewModelMixin, NotificationMixin, CanAccessMixin],
  data() {
    return {
      loading: false,
      modelEntity: this.$api.facilities.sections,
      entity: 'Section Risk Codes',
      componentAccess: {
        canEdit: {
          route: 'facilities.sections.riskCodes.edit',
          access: false,
        },
      }
    };
  },
  computed: {
    id() {
      return this.$route.params.sectionId;
    }
  },
  methods: {
    getParams() {
      const params = this.getModelCopy();

      const multiReferences = [
        {
          array: 'risk_codes',
          key: ['LloydsRiskCode_FK'],
        },
      ];

      this.setMultiReferences(multiReferences);

      delete params.Facility_FK;
      delete params.Section_FK;

      return params;
    },
    async fetch() {
      try {
        const { data } = await this.$api.facilities.sections.riskCodes(this.id)
        this.model = {
          id: this.id,
          risk_codes: data.data,
        }
      } catch (e) {
      }
    },
    async deleteRiskCode($riskCodeId) {
      this.loading = true;

      try {
        const {data} = await this.$api.facilities.sections.deleteRiskCode(
            this.$route.params.sectionId,
            $riskCodeId
        );

        this.notifySuccess('Section updated');
      } catch (e) {
        this.notifyError('Section failed to be update');
        console.error(e)
      } finally {
        await this.reloadForm();
        this.loading = false;
      }
    }
  },
};
</script>

<style scoped>

</style>
